import React, { useState, useCallback, useContext } from 'react';

import LiConcordo from './LiEConcordo';

import { ReactComponent as EnterValueIcon } from '../../../../assets/novosicones/Renegociacao/inventory_black_24dp.svg';
import { ReactComponent as TotalValueIcon } from '../../../../assets/novosicones/Renegociacao/document_scanner_black_24dp.svg';
import { ReactComponent as NumberOfParcelsIcon } from '../../../../assets/novosicones/Renegociacao/format_list_numbered_black_24dp.svg';
import { ReactComponent as ParcelsDueDateIcon } from '../../../../assets/novosicones/Renegociacao/event_black_24dp.svg';
import { ReactComponent as EnterDueDateIcon } from '../../../../assets/novosicones/Renegociacao/today_black_24dp.svg';
import Paginacao from '../../../Paginacao';
import { BeneficiosText, SimulacaoValor } from './styles';
import { ItemsContainer } from '../styles';
import { ContextRenegociacao } from '../../../../services/renegociacao';

import { Item, ItemContent } from '../DadosUsuario/styles';
import BtnAprovacao from './BtnAprovacao';

import formatCurrent from '../../../../Utils/formatCurrent';

const Simulacao = ({
  handleShowSimulacao,
  tema,
  regras,
  contratoSelecionado,
  setshowParcelasPagar,
  setShowRenegociacao,
  getParcelasAPagar,
}) => {
  const IMPORTANT_ICON_STYLE = {
    height: '35px',
    width: '35px',
    fill: tema.primaryColor,
  };

  const { simulacaoResult } = useContext(ContextRenegociacao);
  const handleVencimentoDate = (date, addMonth = 1) => {
    let dt;
    if (!(date instanceof Date)) {
      const day = Number(regras.vencimentoParcelas.split(' ')[2]);

      dt = new Date();
      dt.setDate(day);
    } else {
      dt = new Date(date);
    }

    dt.setMonth(dt.getMonth() + addMonth);

    return dt;
  };

  const entrada = {
    valorRenegociacao: regras?.entrada,
    dataVencimento: regras.vencimentoEntrada.date,
    numeroParcela: 1,
    totParc: 1,
    descricaoParcela: 'Entrada',
  };

  const parcelasARenegociar = [
    ...Array(simulacaoResult.Quantidade_Parcela_Pos_Habitese),
  ].map((_, index) => {
    const addMonth = index + (regras?.mesVencimentoPrimeiraParcela?.id ?? 1);

    return {
      valorRenegociacao: simulacaoResult.Valor_Parcela_Pos_Habitese,
      dataVencimento: handleVencimentoDate(regras.vencimentoParcelas, addMonth),
      numeroParcela: index + 1,
      totParc: simulacaoResult.Quantidade_Parcela_Pos_Habitese,
      descricaoParcela: 'Renegociação',
    };
  });

  parcelasARenegociar.unshift(entrada);

  // console.log(parcelasARenegociar);

  const NORMAL_ICON = {
    fill: '#4D4D4D',
  };

  const IMPORTANT_FIELD_STYLE = { height: '60px' };

  const [concordo, setConcordo] = useState(false);

  const handleConcordo = useCallback(() => {
    setConcordo((prevState) => !prevState);
  }, []);

  const onAprovacao = async () => {
    contratoSelecionado.elegivelRenegociacao = false;
    handleShowSimulacao();
    setShowRenegociacao(false);
    setshowParcelasPagar(true);
    await getParcelasAPagar();
  };

  const calcTotalReajustado = () => {
    return (
      simulacaoResult.Valor_Parcela_Pos_Habitese *
        simulacaoResult.Quantidade_Parcela_Pos_Habitese +
      regras?.entrada
    );
  };

  const calcTotalParcelado = () => {
    return (
      simulacaoResult.Valor_Parcela_Pos_Habitese *
      simulacaoResult.Quantidade_Parcela_Pos_Habitese
    );
  };

  const vencimentoParcelasText = `${
    regras?.vencimentoParcelas
  } a partir de ${regras?.mesVencimentoPrimeiraParcela?.nome.toLowerCase()}`;

  return (
    <>
      <BeneficiosText style={{ marginTop: 0 }}>
        Existem alguns benefícios em uma nova negociação de suas parcelas em
        atraso. Por exemplo, a possibilidade de diminuição do valor das
        parcelas, bem como a chance de esticar o prazo de pagamento do seu
        imóvel. Legal, não é?
      </BeneficiosText>
      <ItemsContainer>
        <Item>
          <span>
            <b>Valor total reajustado (entrada + parcelamento):</b>
          </span>
          <ItemContent style={IMPORTANT_FIELD_STYLE}>
            <TotalValueIcon style={IMPORTANT_ICON_STYLE} />

            <SimulacaoValor important tema={tema}>
              {formatCurrent(calcTotalReajustado())}
            </SimulacaoValor>
          </ItemContent>
        </Item>
        <Item>
          <span>
            <b>Valor de entrada:</b>
          </span>
          <ItemContent style={IMPORTANT_FIELD_STYLE}>
            <EnterValueIcon style={IMPORTANT_ICON_STYLE} />

            <SimulacaoValor important tema={tema}>
              {formatCurrent(regras?.entrada)}
            </SimulacaoValor>
          </ItemContent>
        </Item>
        <Item>
          <span>
            <b>Número de parcelas:</b>
          </span>
          <ItemContent style={IMPORTANT_FIELD_STYLE}>
            <NumberOfParcelsIcon style={IMPORTANT_ICON_STYLE} />
            <SimulacaoValor important tema={tema}>
              {regras?.numeroParcelas}
            </SimulacaoValor>
          </ItemContent>
        </Item>
        <Item>
          <span>
            <b>Vencimento das parcelas:</b>
          </span>
          <ItemContent>
            <ParcelsDueDateIcon style={NORMAL_ICON} />
            <SimulacaoValor>{vencimentoParcelasText}</SimulacaoValor>
          </ItemContent>
        </Item>
        <Item>
          <span>
            <b>Vencimento da entrada:</b>
          </span>
          <ItemContent>
            <EnterDueDateIcon style={NORMAL_ICON} />
            <SimulacaoValor>{regras?.vencimentoEntrada.nome}</SimulacaoValor>
          </ItemContent>
        </Item>
        <Item>
          <span>
            <b>Valor total parcelado:</b>
          </span>
          <ItemContent>
            <EnterDueDateIcon style={NORMAL_ICON} />
            <SimulacaoValor>
              {formatCurrent(calcTotalParcelado())}
            </SimulacaoValor>
          </ItemContent>
        </Item>
      </ItemsContainer>
      <BeneficiosText>
        <span>Prezado(a) cliente,</span>
        <br />
        <br />
        <span>
          Na renegociação das parcelas será incluido juros e correção monetária,
          que totalizam 1,5% ao mês.
        </span>
      </BeneficiosText>
      <LiConcordo
        tema={tema}
        handleConcordo={handleConcordo}
        concordo={concordo}
      />
      <BtnAprovacao
        handleShowSimulacao={handleShowSimulacao}
        onAprovacao={onAprovacao}
        concordo={concordo}
        tema={tema}
        regras={regras}
        contratoSelecionado={contratoSelecionado}
      />
      <Paginacao
        parcelas={parcelasARenegociar}
        tema={tema}
        tipo='aPagar'
        simulacaoRenegociacao
        parcelasAPagar={parcelasARenegociar}
      />
      ;
    </>
  );
};

export default Simulacao;
